function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_66",
  "data-name": "Group 66",
  transform: "translate(-1.637 0.1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_19",
  "data-name": "Path 19",
  d: "M10.656,18.7V.984a.328.328,0,0,1,.328-.328H22.8a.329.329,0,0,1,.328.328h.656A.985.985,0,0,0,22.8,0H10.984A.985.985,0,0,0,10,.984V18.7a.985.985,0,0,0,.984.984h.328v-.656h-.328A.329.329,0,0,1,10.656,18.7Z",
  transform: "translate(-8.263)",
  fill: "#222",
  stroke: "#222",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_20",
  "data-name": "Path 20",
  d: "M37.328,112a.328.328,0,0,0,0,.656h8.2a.326.326,0,0,0,.24-.106,3.774,3.774,0,0,1-.945-.55Z",
  transform: "translate(-30.999 -93.524)",
  stroke: "#000",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_21",
  "data-name": "Path 21",
  d: "M35.125,28.375a.329.329,0,0,1-.328.328H22.984a.329.329,0,0,1-.328-.328V10.984a.328.328,0,0,1,.328-.328H34.8a.328.328,0,0,1,.328.328v9.057a3.744,3.744,0,0,1,.656.146v-9.2A.985.985,0,0,0,34.8,10H22.984a.985.985,0,0,0-.984.984V28.375a.985.985,0,0,0,.984.984H34.8a.985.985,0,0,0,.984-.984v-1a3.744,3.744,0,0,1-.656.146Z",
  transform: "translate(-18.294 -8.359)",
  fill: "#222",
  stroke: "#222",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_22",
  "data-name": "Path 22",
  d: "M47.763,27.557h-1.11a.6.6,0,0,0-.656.63v.627c0,.176,0,.712.539.712h4.828c.539,0,.539-.536.539-.712v-.627a.6.6,0,0,0-.656-.63H50.228a.149.149,0,0,1-.134-.082,1.63,1.63,0,0,1-.111-1.194,4.458,4.458,0,0,1,.283-.7l0-.009a1.879,1.879,0,1,0-2.624.042l0,.005a4.574,4.574,0,0,1,.271.684,1.61,1.61,0,0,1-.117,1.175Zm.788-1.439a5.163,5.163,0,0,0-.306-.778l-.029-.063a.328.328,0,0,0-.079-.107,1.274,1.274,0,0,1-.422-.949,1.223,1.223,0,1,1,2.445,0,1.263,1.263,0,0,1-.389.918.331.331,0,0,0-.069.1l-.028.06a5.071,5.071,0,0,0-.321.8h0a2.285,2.285,0,0,0,.155,1.674.8.8,0,0,0,.72.443h1.018v.6c0,.015,0,.035,0,.056H46.653c0-.021,0-.04,0-.056v-.6h1.11a.653.653,0,0,0,.586-.361l.041-.081a2.263,2.263,0,0,0,.161-1.653Z",
  transform: "translate(-38.353 -19.067)",
  fill: "#222",
  stroke: "#222",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_23",
  "data-name": "Path 23",
  d: "M83.117,75a3.117,3.117,0,1,0,3.117,3.117A3.117,3.117,0,0,0,83.117,75Zm0,5.578a2.461,2.461,0,1,1,2.461-2.461,2.461,2.461,0,0,1-2.461,2.461Z",
  transform: "translate(-66.779 -62.695)",
  stroke: "#000",
  strokeWidth: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_24",
  "data-name": "Path 24",
  d: "M92.438,88.558l-1.421.98-.439-.52a.328.328,0,1,0-.5.424l.631.747a.328.328,0,0,0,.437.058L92.811,89.1a.328.328,0,1,0-.373-.54Z",
  transform: "translate(-75.138 -73.98)",
  stroke: "#000",
  strokeWidth: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_26",
  "data-name": "Path 26",
  d: "M37.328,96a.328.328,0,1,0,0,.656h6.2A3.75,3.75,0,0,1,43.414,96Z",
  transform: "translate(-30.999 -79.775)",
  stroke: "#000",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_27",
  "data-name": "Path 27",
  d: "M43.53,88h-6.2a.328.328,0,0,0,0,.656h6.085A3.75,3.75,0,0,1,43.53,88Z",
  transform: "translate(-30.999 -74.025)",
  stroke: "#000",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_29",
  "data-name": "Path 29",
  d: "M45.531,72h-8.2a.328.328,0,0,0,0,.656h7.5a3.774,3.774,0,0,1,.945-.55A.326.326,0,0,0,45.531,72Z",
  transform: "translate(-30.999 -60.275)",
  stroke: "#000",
  strokeWidth: 0.3
}));

var SvgReconciliationSvg = function SvgReconciliationSvg(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.869,
    height: 21.2,
    viewBox: "0 0 17.869 21.2",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReconciliationSvg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reconciliationSvg.67884189.svg";
export { ForwardRef as ReactComponent };